import { FormControl, Stack, Text } from "@chakra-ui/react";
import React from "react";
import CFormErrors from "./CFormErrors";
import Select from "react-select";

const CMultiSelect = ({
  options,
  changeAction,
  label,
  formik,
  name,
  index,
  value,
  ...rest
}) => {
  const labelColor = "gray";

  const errorsMsg = formik?.errors[name];

  const handelOptions = options?.map((val) => {
    return {
      label: val?.name,
      value: val?.id,
      color: val?.color,
    };
  });
  const valueData =
    typeof formik?.values[name] != "object"
      ? handelOptions?.find((val) => val?.value == formik?.values[name])
      : formik?.values[name];
  const indexs = {
    0: 10,
    1: 9,
    2: 8,
    3: 7,
    4: 6,
    5: 5,
    6: 4,
    7: 3,
    8: 2,
    9: 1,
    10: 0,
  };
  const defaultStyle = {
    color: labelColor,
    fontSize: "18px",
    fontFamily: "Jost",
    mb: 2,
  };
  const colourStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: "#FBFBFB",
      padding: "8px",
      borderColor: isFocused ? "transparent" : "transparent",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,

        color: "black",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
        },
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "white",
        border: "1px solid #E6E6E6",
        color: "#707070",
        fontSize: "18px",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#707070",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#ccc",
      ":hover": {
        backgroundColor: "#ccc",
        color: "white",
      },
    }),
  };
  return (
    <Stack
      w={"100%"}
      p="0"
      justifyContent="center"
      flexDirection={"column"}
      position="relative"
      zIndex={`${100 + indexs[index]} !important`}
      loadingMessage={() => <p>loading...</p>}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <FormControl fullWidth>
        {label && (
          <Text as="span" sx={defaultStyle}>
            {label}
          </Text>
        )}

        <Select
          styles={colourStyles}
          id={name}
          name={name}
          options={handelOptions}
          onChange={(value) => changeAction(value)}
          value={valueData || value}
          placeholder={label}
          className="search-select"
          isMulti={true}
          {...rest}
        />
      </FormControl>
      <CFormErrors errorsMsg={errorsMsg} />
    </Stack>
  );
};

export default CMultiSelect;
